import { render, staticRenderFns } from "./VersionPage.vue?vue&type=template&id=72b194c8"
import script from "./VersionPage.vue?vue&type=script&lang=js"
export * from "./VersionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports